export class AuditRequest{
    public AuditID:number;
    public IsCurrent:boolean = true;
    public LocationID:number = -1;
    constructor(AuditID:number,IsCurrent:boolean = true,LocationID:number){
        this.AuditID = AuditID;
        this.IsCurrent = IsCurrent;
        this.LocationID = LocationID;
    }
}